/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BodyUpdateSession } from '../../models/body-update-session';
import { Session } from '../../models/session';

export interface UpdateSession$Params {
  session_id: string;
      body: BodyUpdateSession
}

export function updateSession(http: HttpClient, rootUrl: string, params: UpdateSession$Params, context?: HttpContext): Observable<StrictHttpResponse<Session>> {
  const rb = new RequestBuilder(rootUrl, updateSession.PATH, 'put');
  if (params) {
    rb.path('session_id', params.session_id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Session>;
    })
  );
}

updateSession.PATH = '/sessions/{session_id}';
